import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { DeleteShipParmsModel, deleteShipTo, DeleteShipToParameter } from "@tSurya/Services/DeleteShipService";

type HandlerType = ApiHandler<
    DeleteShipToParameter & HasOnSuccess<DeleteShipParmsModel> & HasOnError<string>,
    DeleteShipParmsModel
>;

export function normalizeDeleteError(raw: string): string {
    if (!raw) {
        return "An unknown error occurred.";
    }
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.ErrorMessage === "string") {
            return parsed.ErrorMessage;
        }
    } catch {
        return raw;
    }
    return raw;
}

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await deleteShipTo(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            const normalized = normalizeDeleteError(error.errorJson.message);
            props.parameter.onError?.(normalized);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const deleteShipToAddress = createHandlerChainRunner(chain, "deleteShipToAddress");
export default deleteShipToAddress;
